var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("g", [
      _c("path", { style: _vm.path.style, attrs: { d: _vm.path.data } })
    ]),
    _vm._v(" "),
    _c("g", [
      _vm.pathFilter
        ? _c(
            "text",
            {
              staticClass: "cf-node__link-filter",
              style: _vm.pathFilter.style,
              attrs: {
                transform: _vm.pathFilter.transform,
                "font-family": _vm.isFilterNode ? "FontAwesome" : "",
                "dominant-baseline": "middle",
                "text-anchor": "middle"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("editNodeLinks", _vm.line.originNode)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.isFilterNode ? "" : _vm.pathFilter.filterValue) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }